<template>
  <b-card>
    <!-- form -->
    <b-form>
      <b-row>
        <b-col md="6" v-if="colKanwil">
          <b-form-group
            label-for="wilayahList"
            label="Wilayah"
          >
            <v-select
              v-model="optionsLocal.member.wilayah"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="kanwilOptions.options"
              :reduce="val => val.value"
              :clearable="false"
              input-id="wilayah"
              @input="(val) => changeUPT(val)"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" v-if="colUpt">
          <b-form-group
            label-for="kabKotaList"
            label="UPT"
          >
            <v-select
              v-model="optionsLocal.member.upt"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="uptOptions.options"
              :reduce="val => val.value"
              :clearable="false"
              input-id="upt"
            />
          </b-form-group>
        </b-col>
        <b-col md="6" v-if="colDitjen">
          <b-form-group
            label-for="strukturOrganisasiList"
            label="Struktur Organisasi"
          >
            <v-select
              v-model="optionsLocal.member.struktur_organisasi_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="strukturOrganisasiOptions.options"
              :reduce="val => val.value"
              :clearable="false"
              input-id="strukturOrganisasi"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="phone"
            label="HP / Telepon"
          >
            <cleave
              id="phone"
              v-model="optionsLocal.member.nomor_hp"
              class="form-control"
              :raw="false"
              :options="clevePhone"
              placeholder="HP / Telepon"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="nip"
            label="NIP"
          >
            <cleave
              id="nip"
              v-model="optionsLocal.member.nip"
              class="form-control"
              :raw="false"
              :options="cleveNumber"
              placeholder="NIP"
            />
          </b-form-group>
        </b-col>
        <!-- phone -->

        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-1 mr-1"
            @click="simpan"
          >
            Simpan
          </b-button>
          <!-- <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="reset"
            class="mt-1"
            variant="outline-secondary"
            @click.prevent="resetForm"
          >
            Reset
          </b-button> -->
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BFormTextarea,
} from 'bootstrap-vue'
import store from '@/store'
import storeModule from '@/connection-api/user/storeModule'
import {
  getKanwil,
  getUPT,
  getStrukturOrganisasi,
} from '@/connection-api/master'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'

// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    // BFormInput,
    BRow,
    BCol,
    BCard,
    vSelect,
    Cleave,
  },
  directives: {
    Ripple,
  },
  props: {
    informationData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      kanwilOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Kanwil --' },
        ],
      },
      uptOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih UPT --' },
        ],
      },
      strukturOrganisasiOptions: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Struktur Organisasi --' },
        ],
      },
      // desaOption: ['Desa Parakan Jaya', 'Desa Cimanggu'],
      optionsLocal: {},
      clevePhone: {
        phone: true,
        phoneRegionCode: 'ID',
      },
      cleveNumber: {
        blocks: [18],
        numericOnly: true,
      },
      userData: JSON.parse(localStorage.getItem('userData')),
      colUpt: true,
      colKanwil: true,
      colDitjen: true,
    }
  },
  async mounted() {
    const responseStrukturOrganisasiOptions = await getStrukturOrganisasi()
    this.mappingSelectOption(responseStrukturOrganisasiOptions.data, this.strukturOrganisasiOptions.options)

    const responseKanwilOptions = await getKanwil()
    this.mappingSelectOption(responseKanwilOptions.data, this.kanwilOptions.options)

    if (this.$route.params.id) {
      this.userId = this.$route.params.id
    } else {
      this.userId = this.userData.id
    }
    const USER_APP_STORE_MODULE_NAME = 'pengguna'
    // Register module
    if (this.userData.roles.indexOf('ditjenpas') !== -1
    || this.userData.roles.indexOf('user-ditjenpas') !== -1
    || this.userData.roles.indexOf('helpdesk') !== -1) {
      this.colUpt = false
      this.colKanwil = false
    }

    if (this.userData.roles.indexOf('koordinator') !== -1) {
      this.colUpt = false
      this.colDitjen = false
    }

    if (this.userData.roles.indexOf('users') !== -1) {
      this.colDitjen = false
    }

    if (this.userData.roles.indexOf('admin') || this.userData.roles.indexOf('administrator')) {
      this.colUpt = true
      this.colKanwil = true
    }

    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, storeModule)

    store.dispatch('pengguna/fetchData', { id: this.userId })
      .then(response => {
        this.optionsLocal = response.data.data
        this.reloadUPTOptions(this.optionsLocal.member.wilayah.value)
      })
      .catch(error => {
        if (error.response.status === 404) {
          this.optionsLocal = {}
        }
      })
  },
  methods: {
    changeUPT(value) {
      this.reloadUPTOptions(value)
    },
    async reloadUPTOptions(kanwilId) {
      this.uptFilter = null
      this.uptOptions = {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih UPT --' },
        ],
      }
      const responseUptOptions = await getUPT(kanwilId)
      this.mappingSelectOption(responseUptOptions.data, this.uptOptions.options)
    },
    simpan() {
      const localData = this.optionsLocal
      if (!localData.member) {
        localData.member = {}
      }
      this.$emit('clicked', localData)
    },
    resetForm() {
      // this.optionsLocal = {}
    },
    mappingSelectOption(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.id,
          })
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
